import ManualUpdation from "modules/warehouse/ManualUpdation";
import OutwardIntransit from "modules/warehouse/OutwardIntransit";
import Stock from "modules/warehouse/Stock";
import WarehouseInwards from "modules/warehouse/WarehouseInwards";
import WarehouseOutwards from "modules/warehouse/WarehouseOutwards";
import WarehouseSupplier from "modules/warehouse/WarehouseSupplier";
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import WarehouseReport from "./WarehouseReport";

function Warehouse() {
  const [activeTab, setActiveTab] = useState("stock");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const tab = searchParams.get("tab");
    setActiveTab(tab);
  }, []);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/warehouse?tab=${tabKey}`);
  };

  return (
    <div>
      <Tabs
        variant="pills"
        defaultActiveKey="inwards"
        id="uncontrolled-tab-example"
        className=""
        activeKey={activeTab}
        onSelect={handleTabChange}
      >
        <Tab eventKey="stock" title="Stock" className="mt-1">
          {activeTab === "stock" && <Stock />}
        </Tab>
        <Tab eventKey="inwards" title="Warehouse Inwards" className="mt-1">
          {activeTab === "inwards" && <WarehouseInwards />}
        </Tab>
        <Tab eventKey="outwards" title="Warehouse OutWards" className="mt-1">
          {activeTab === "outwards" && <WarehouseOutwards />}
        </Tab>
        <Tab eventKey="intransit" title="Outward Intransit" className="mt-1">
          {activeTab === "intransit" && <OutwardIntransit />}
        </Tab>
        <Tab eventKey="updation" title="Manual Updation" className="mt-1">
          {activeTab === "updation" && <ManualUpdation />}
        </Tab>
        <Tab eventKey="supplier" title="Warehouse Supplier" className="mt-1">
          {activeTab === "supplier" && <WarehouseSupplier />}
        </Tab>
        <Tab
          eventKey="warehouse-report"
          title="Warehouse Report"
          className="mt-1"
        >
          {activeTab === "warehouse-report" && <WarehouseReport />}
        </Tab>
      </Tabs>
    </div>
  );
}

export default Warehouse;
